import React, { Component } from 'react';

class MerchantTermsAndConditions extends Component {
  render() {
    return (
      <div className="merchantTermsContainer">
        <span className="merchantTerms__header">Buypower Merchant Terms and Conditions</span>
        <span className="merchantTerms__date">Last Updated: 12th March, 2020</span>
        <p className="merchantTerms__termshead">
          These Terms and Conditions (these <b>Terms</b>) shall govern your relationship with DatapexDrifty Technologies Limited 
          (hereafter referred to as Buypower) in your capacity  as amerchant for the marketing, sale and distribution of Buypower’s 
          products and services (the Buypower Products). By registering on the Buypower Merchant 
          Platform (the Buypower Platform), you become a Buypower merchant and you agree to be 
          bound by these Terms. If you do not accept these Terms, PLEASE DO NOT register on the Buypower Platform. 
        </p>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>1.</span> 
            <span>General Terms and Conditions</span>
          </div>
          <div>
            <span className="u-mr-6">1.1</span> 
            <span>
              By registering on the Buypower Platform, you warrant that you are at least 18 years old or a duly registered 
              corporate entity and are legally capable of entering into binding contracts.
            </span>
          </div>
          <div>
            <span className="u-mr-6">1.2</span> 
            <span>
              You agree to provide true, accurate, current and complete information about yourself or your 
              organization (as applicable) as requested in the registration form and else where on the Buypower 
              Platform and agree to update such information where it changes.
            </span>
          </div>
          <div>
            <span className="u-mr-6">1.3</span> 
            <span>
              You agree not to: use the Buypower Platform in any way that is, or may be, damaging to the 
              Buypower Platform; use the Buypower Platform in any way that impacts user access to the Buypower 
              Platform; use the Buypower Platform contrary to applicable laws and regulations, or in a way that 
              causes, or may cause, harm to the Buypower Platform, or to any person or business entity; engage 
              in any data mining, data harvesting, data extracting or any other similar activity in relation to 
              the Buypower Platform, or while using the Buypower Platform; or use this Buypower Platform to engage 
              in any advertising or marketing.
            </span>
          </div>
          <div>
            <span className="u-mr-6">1.4</span> 
            <span>
              These Terms may be amended at any time by Buypower. It is your responsibility to regularly read 
              through them. We reserve the right to modify or withdraw the Buypower Platform at any time without 
              recourse or liability to you.
            </span>
          </div>
          <div>
            <span className="u-mr-6">1.5</span> 
            <span>
              The information or personal details that you provide us with shall be processed pursuant to our Privacy 
              Policy. By using or registering on the Buypower Platform you are consenting to the processing of such information 
              and details. We shall not be responsible for any loss which you may suffer as a result of any false information or details 
              which you have provided to us.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>2.</span> 
            <span>Merchant Services</span>
          </div>
          <div>
            <span className="u-mr-6">2.1</span> 
            <span>
              You agree and understand that Buypower appoints you on a non-exclusive basis and you hereby accept the 
              appointment on the terms set out in these Terms tomarket, sell and distribute the Buypower Products to 
              clients and potential clients.
            </span>
          </div>
          <div>
            <span className="u-mr-6">2.2</span> 
            <span>
              You agree that in performing your duties under these Terms, you shall comply with all Buypower’s policies 
              and manuals which may be provided to you by Buypower from time to time as well as all laws, regulations, 
              orders or policies as may beprescribed by any federal or state laws or any regulatory agencies, to 
              which you are subject to.
            </span>
          </div>
          <div>
            <span className="u-mr-6">2.3</span> 
            <span>
              You shall faithfully, competently and diligently perform your duties and exercise the powers which Buypower 
              may from time to time properly assign to you.
            </span>
          </div>
          <div>
            <span className="u-mr-6">2.4</span> 
            <span>
              You shall have no authority to make any representation or offer any guarantees on behalf of Buypower or in in respect 
              of Buypower’s services other than those expressly authorized by Buypower.
            </span>
          </div>
          <div>
            <span className="u-mr-6">2.5</span> 
            <span>
              In the course of performing your duties under these Terms, you may come incontact with equipment or other property belonging to Buypower. 
              You shall be responsible for any loss or damage to any equipment or other property of Buypower in your possession and you shall be liable 
              to replace or repair any such lost ordamaged property to its full value.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>3.</span> 
            <span>Your E-Wallet</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              You are required to maintain an electronic wallet (e-wallet) with Buypower which you shall pre-fund to enable you make purchases on the Buypower Platform. 
              You agree that you shall not make any purchases on the Buypower Platform in excess of the funds prefunded into your e-wallet. Buypower shall not be under an 
              obligation to process any purchase order from you on the Buypower Platform where the funds in your e-wallet are not sufficient to cover such purchase.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>4.</span> 
            <span>Commissions</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              You will be entitled to a commission which would be determined by Buypower based on your sales volume. The timing and mode of 
              payment of the commission will be communicated to you by Devcenter. The applicable commission and the timing of the payment is 
              subject to change at any time in our sole discretion and if you do not agree to any such changes, you should contact Buypower 
              to cancel your account and terminate these Terms. Buypower will also use good faith efforts to notify you prior to the effectiveness 
              of any significant change to the applicable commission but you are responsible for reviewing the applicable commission from time to 
              time and remaining aware of the commission.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>5.</span> 
            <span>Indemnity</span>
          </div>
          <div>
            <span className="u-mr-6">5.1</span> 
            <span>
              You shall be liable for all your acts and omissions which results in any loss, damage or liability to 
              any third party. You shall indemnify, defend and hold harmless, Buypower and its directors, officers, 
              agents and employees (the Indemnitees) from and against any and all fines, loss, damage, injury or liability, 
              including reasonable attorney’s fees and cost relating to the foregoing suffered by the Indemnitees, resulting 
              or arising directly or indirectly from your acts, omissions or breach of these Terms.
            </span>
          </div>
          <div>
            <span className="u-mr-6">5.2</span> 
            <span>
              In no event shall Buypower nor any of its officers, directors and employees, be liable to you for anything arising out of or in 
              any way connected with your use of the Buypower Platform or under these Terms, whether such liability is under contract, tort or otherwise 
              unless the loss or damage suffered by you is caused as a result of the willful misconduct or gross negligence of Buypower. Buypower including 
              its officers, directors and employees shall not be liable for any indirect, consequential or special liability arising out of or in any way related 
              to your use of the Buypower Platform or under these Terms.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>6.</span> 
            <span>Disclaimer</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              Buypoer does not warrant or guarantee that your use of the Buypower platform shall be without fault or error. Buypower hereby disclaims all 
              warranties, whether express or implied or otherwise without limitation that the Buypower platform is free from defect or use for a particular purpose, 
              You bear the risk as to using the Buypower platform for any purpose and quality. Buypower is not and will not be liable for any risk suffered by your hardware or software, 
              be it that they become deleted or corrupted or that someone unauthorized gained access to your information. Buypower does not guarantee or warrant that the Buypower platform shall 
              be free from viruses, attacks, corruption, hacking and intrusion from third parties. Buypower shall not be liable for any data charges incurred by you during the use of this service.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>7.</span> 
            <span>Viruses, Hackering and other Cybercrimes</span>
          </div>
          <div>
            <span className="u-mr-6">7.1</span> 
            <span>
              You may not misuse the Buypower Platform by knowingly introducing viruses, Trojans, worms, logic bombs or other material which is malicious or technologically 
              harmful. You will not attempt to have any unauthorized access to the Buypower Platform, to the server which hosts the Buypower Platform or to any other server, 
              computer or data base related to our website.
            </span>
          </div>
          <div>
            <span className="u-mr-6">7.2</span> 
            <span>
              You undertake not to attack the Buypower Platform via a denial of service attack or a distributed denial of service attack. We will report any such breach to the 
              relevant law enforcement authority and we will co-operate with the appropriate authority to disclose the identity of the hacker. Likewise, in the event of such a breach, 
              your right to use the Buypower Platform will cease immediately.
            </span>
          </div>
          <div>
            <span className="u-mr-6">7.3</span> 
            <span>
              We will use reasonable care and skill to ensure that the Buypower Platform is safe, secure and free from bugs, viruses and other defects. Except to the extent it results from 
              our failure to do so, we accept no liability for any loss or damage resulting from any denial of service attack, virus or any other software or material which is malicious or 
              technologically harmful to your computer, equipment, data or material resulting from the use of the Buypower Platform or from the downloading of the contents thereof or of such 
              contents to which the Buypower Platform redirects.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>8.</span> 
            <span>Links from the Buypower Platform</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              We may have links from the Buypower Platform to other third-party websites and materials; such links are provided exclusively for information purposes and we do not have any control 
              whatsoever over the contents of such websites or materials. Accordingly, we accept no liability whatsoever for any loss or damage which may arise from the use of such links.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>9.</span> 
            <span>Events outside our control</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              We will not be liable or responsible for any failure to perform, or delay in performance of, any of our obligations these Terms that is caused by events outside our reasonable control. 
              An event outside our control includes any act, event, non-happening, omission or accident beyond our reasonable control and includes in particular (without limitation) the following:
              <ul className="u-pd-10">
                <li>Strikes, lock-outs or other industrial action.</li>
                <li>Civil commotion, riot, invasion, terrorist attack or threat of terrorist attack, war (whether declared or not) or threat or preparation for war.</li>
                <li>Fire, explosion, storm, flood, earthquake, subsidence, epidemic or other natural disaster.</li>
                <li>The acts, decrees, legislation, regulations or restrictions of any government.</li>
              </ul>
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>10.</span> 
            <span>Written Communications</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              When using our site, you accept that communication with us will be mainly electronic. We will contact you by e-mail or provide you with information by posting notices on our website. 
              For contractual purposes, you agree to this electronic means of communication and you acknowledge that all contracts, notices, information and other communications that we provide 
              to you electronically comply with any legal requirement that such communications be in writing.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>11.</span> 
            <span>Notices</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              All notices given by you to us should be given to us via email to hello@buypowerng.com. We may give notice to you at either the e-mail or postal address you provide to us when registering on 
              the Buypower Platform. Notice will be deemed received and properly served immediately when posted on our website, 24 hours after an e-mail is sent, or three days after the date of posting of 
              any letter. In proving the service of any notice, it will be sufficient to prove, in the case of a letter, that such letter was properly addressed, stamped and placed in the post and, in the 
              case of an e-mail that such e-mail was sent to the specified e-mail address of the addressee.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>12.</span> 
            <span>Waivers</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              If we fail, at any time during the term of these Terms, to insist upon strict performance of any of your obligations under these Terms, or if we fail to exercise any of the rights or remedies 
              to which we are entitled under these Terms, this shall not constitute a waiver of such rights or remedies and shall not relieve you from compliance of such obligations. A waiver by us of any 
              default shall not constitute a waiver of any subsequent default arising from these Terms. No waiver by us of any of these Terms shall be effective unless it is expressly stated to be a waiver 
              and is communicated to you in writing in accordance with the paragraph on Notices above.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>13.</span> 
            <span>Severability</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              If any of these Terms are determined by any competent authority to be invalid, unlawful or unenforceable to any extent, such term, condition or provision will to that extent be severed from 
              the remaining terms, conditions and provisions which will continue to be valid to the fullest extent permitted by law.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>14.</span> 
            <span>Law and Jurisdiction</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              These Terms shall be governed by Nigerian Law. Any dispute arising from or related to the use of the Buypower Platform or under these Terms shall be subject to the exclusive jurisdiction of 
              the Nigerian courts. You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to use of the Buypower Platform or from these Terms 
              must be filed within one (1) year after such claim or cause of action arose or be forever barred.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>15.</span> 
            <span>Termination</span>
          </div>
          <div>
            <span className="u-mr-6">&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            <span>
              These Terms shall continue to apply until terminated by you upon giving notice to Buypower in writing or at any time by Buypower. We may also decide to suspend or terminate your access to the 
              Buypower Platform where you have breached any provisions of these Terms. Any termination of this Agreement (however occasioned) shall not affect any accrued rights or liabilities nor shall it 
              affect the coming into force or the continuance in force of any provision hereof which is expressly or by implication intended to come into or continue in force on or after such termination.
            </span>
          </div>
        </div>
        <div className="merchantTerms__body">
          <div className="merchantTerms__body__head">
            <span>16.</span> 
            <span>General</span>
          </div>
          <div>
            <span className="u-mr-6">16.1</span> 
            <span>
              Your relationship with Buypower under these Terms will at all times remain, one of independent contractors and not that of employer and employee, franchisor and franchisee or joint venturers. 
              These Terms do not establish you as the representative or agent of Buypower for any purpose other than for the purpose of you carrying out your duties under these Terms. You are not authorized 
              to make contracts in the name Buypower or to transact any business in the name of Buypower or to assume or create any obligation or responsibility binding on Buypower in any matter whatsoever.
            </span>
          </div>
          <div>
            <span className="u-mr-6">16.2</span> 
            <span>
              For as long as you remain a merchant of Buypower and for the duration of these Terms, you shall not sell, market or distribute any products or engage in or perform, directly or indirectly, either 
              as principal, distributor, agent, intermediary, employee, or in any other capacity, any activities,  which in any way compete with the Buypower Products or the business of Buypower.
            </span>
          </div>
          <div>
            <span className="u-mr-6">16.3</span> 
            <span>
              During your time as a Buypower merchant and at all times thereafter you agree that you shall not disclose to any person or entity any of the procedures, practices, dealings or other information concerning 
              the business, finances, transactions or affairs of  Buypower that is disclosed by Buypower to you, in whatever form or which constitutes a trade secret, including any verbal or written information or other 
              documentation (collectively, “Confidential Information”). These provisions shall not apply to disclosure required by law or by any relevant national or supranational regulatory authority in which circumstance 
              you shall, if practicable, supply a copy of the required disclosure to Buypower before it is disclosed and comply with the reasonable requests of Buypower regarding the extent of such disclosure. 
              This confidentiality obligation shall survive the termination of these Terms shall not be limited in time.
            </span>
          </div>
          <div>
            <span className="u-mr-6">16.4</span> 
            <span>
              You shall not assign any right or obligation hereunder in whole or in part, without the prior written consent of the Company.
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default MerchantTermsAndConditions;


// WEBPACK FOOTER //
// ./src/components/MerchantTermsAndConditions.js